import React, { Children, isValidElement, cloneElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MenuTitle from './MenuTitle';

function getMenuItems(children) {
  const items = [];
  Children.forEach(children, item => {
    if (isValidElement(item)) {
      items.push(item);
    }
  });
  return items;
}

/**
 * MenuItemGroup
 */
export default function MenuItemGroup(props) {
  const {
    children,
    prefixCls,
    className,
    title,
    prefix,
    disabled,
    mode,
    close,
    onChange,
    defaultIsOpen,
    level,
    compact,
    ...other
  } = props;
  const menu = getMenuItems(children).map((item, key) =>
    cloneElement(item, {
      level: compact ? level : level + 1,
      key: item.props.value || `menu-group-${key}`,
      compact,
      close,
      disabled,
    }),
  );
  const classes = classNames(prefixCls, {}, className);
  const titleClasses = classNames(`${prefixCls}-title`);
  return (
    <li className={classes}>
      <Fragment>
        <MenuTitle
          silent
          prefix={prefix}
          compact={compact}
          level={level}
          disabled={disabled}
          className={titleClasses}>
          {title}
        </MenuTitle>
        <ul {...other} className={`${prefixCls}-list`}>
          {menu}
        </ul>
      </Fragment>
    </li>
  );
}

MenuItemGroup.displayName = 'NeatUI.MenuItemGroup';
MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.propTypes = {
  /**
   * 类前缀
   * */
  prefixCls: PropTypes.string,
  /** 子菜单标题 */
  title: PropTypes.node,
  /** 分组标题前缀 */
  prefix: PropTypes.node,
  /** 关闭父组件方法 */
  close: PropTypes.func,
  /** 组件所处层数（用于确定缩进） */
  level: PropTypes.number,
  /** 是否紧凑显示 */
  compact: PropTypes.bool,
};

MenuItemGroup.defaultProps = {
  prefixCls: 'ne-menu-item-group',
  title: '',
  level: 1,
  compact: false,
};



// WEBPACK FOOTER //
// ./src/menu/MenuItemGroup.jsx